import { useParams } from "react-router";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";
import { useTranslate } from "@refinedev/core";

import { isValidCPF } from "@modules/users/utils/isValidCPF";
import { EditUserFormValues, editUserSchema } from "@modules/users/validations/editUserSchama";
import { useEditUserMutation } from "@modules/users/services/mutations";

export function useUserEditForm() {
  const { id } = useParams();
  const translate = useTranslate();
  const { mutateAsync, isPending } = useEditUserMutation();

  const methods = useForm<EditUserFormValues>({
    resolver: zodResolver(editUserSchema()),
  });

  const {
    handleSubmit,
    refineCore: { formLoading },
  } = methods;

  return {
    methods,
    handleSubmit,
    mutateAsync,
    isPending,
    formLoading,
    id,
  };
}
